<template>
  <div
    :class="['game-item-wrap', IsMobile ? 'h5-box' : '', isHotNew ? 'isHotNewGame' : '']"
    v-if="hidegd(item)"
    v-exposure="{
      gameGroupSid: item.gameGroupSid,
      eid: item.eid,
      oid: item.oid,
      isMatchKeys: item.isRecommend || false,
    }"
    :data-id="item.eid"
    @mouseenter="pcPayGame(item)"
    @mouseleave="pcLeaveGame"
  >
    <el-skeleton :loading="skeletonLoading" animated :throttle="0">
      <template slot="template">
        <el-skeleton-item variant="image" style="width: 100%" :style="{ height: $px2rem(getImgHeight) }" />
        <el-skeleton-item variant="text" style="width: 100%; height: 20px; margin: 8px 0" />
      </template>
      <template>
        <div>
          <div v-if="gameShow === 1 && !isHotNew" :class="['game-name', 'top', 'level_show' + levelShow]">
            <div class="game-text">{{ item.gameName }}</div>
          </div>
          <div class="item-img item-img-skeleton" @click="pcOtherPayGame(item)">
            <div
              v-if="gameShow === 2 && !isHotNew"
              :class="[
                item.game_category_id ? 'game-name-bg' + item.game_category_id : 'game-name-bg50',
                'game-name-bg',
                'level_show' + levelShow,
                'top',
              ]"
            >
              <div class="game-text">{{ item.gameName }}</div>
            </div>
            <img
              class="tag-icon"
              v-if="getGameIcon(item.tagKey, item.haveFreeBet) && !isHotNew"
              :src="getGameIcon(item.tagKey, item.haveFreeBet)"
              alt
            />
            <div class="tag-text" v-if="item.haveFreeBet === 'STATUS_BOOL_TRUE' && !isHotNew">{{ $t("Datalang.newly_free1") }}</div>
            <img class="tubiao" v-if="gameImg(item) !== 0 && getGameUrl(item) && !isHotNew" :src="gameImg(item)" alt="" />
            <img
              class="brand-logo"
              v-if="showBrandLogo && item.brandGroupLogo && !isHotNew"
              :src="$utils.returnImgUrl(item.brandGroupLogo)"
              alt
            />

            <!-- <img
              :lazy="getGameUrl(item)"
              :key="getGameUrl(item)"
              ref="bannerHeight"
              alt
              style="display: block"
              class="lazy-load"
            /> -->
            <div class="game-dom-img">
              <div class="game-dom-bg" v-if="isHotNew">
                <img v-if="isHotNew === 1" :src="require('@/lobby_common/assets/game-item/hot.webp')" alt="" />
                <img v-else :src="require('@/lobby_common/assets/game-item/new.webp')" alt="" />
              </div>
              <div v-if="isHotNew === 1" class="absolute game-dom-top">
                <div class="txt1">
                  <span>RTP&nbsp;</span>
                  <span>{{ Math.floor(Math.random() * (110 - 99 + 1)) + 99 }}%</span>
                </div>
                <div class="txt2">
                  <img class="num" :src="require('@/lobby_common/assets/game-item/num.webp')" alt="" />
                  <span>{{ Math.floor(Math.random() * (300 - 100 + 1)) + 100 }}</span>
                </div>
              </div>
              <div v-if="isHotNew" class="absolute game-dom-bottom" :class="isHotNew === 1 ? '' : 'game-dom-bottom1'">
                {{ isHotNew === 1 ? $t("Datalang.home_today_best") : $t("Datalang.HomePage_TYPE_new") }}
              </div>
              <img
                v-lazy="getGameUrl(item)"
                :key="getGameUrl(item)"
                ref="bannerHeight"
                alt
                style="display: block"
                class="lazy-load"
                :class="isHotNew ? 'isHotNewGameImg' : ''"
              />
            </div>

            <!-- 即将上线 || 维护中 -->
            <game-maintai :dataOpt="item" @btnHide="handleBtnHide"></game-maintai>
            <div
              class="shiwan-mark"
              v-if="item.gameGroupSid === currGameId && (isCanTestPlay(item) || isCanNewRoom(item))"
            >
              <div class="collection">
                <Collection :isCollect="isCollectionGame(curGameItem)" :gameGroupSid="currGameId" />
              </div>
              <div class="nomal chuangfang" @click.stop="payGame(item, 2, true)" v-if="isCanNewRoom(item)">
                {{ $t("Datalang.Creatroommode") }}
              </div>
              <div class="nomal" @click.stop="payGame(item, 2)">{{ $t("Datalang.HomePage_TITLE_realmode") }}</div>
              <div class="nomal shiwan" v-if="isCanTestPlay(item)" @click.stop="payGame(item, 1)">
                {{ $t("Datalang.HomePage_TITLE_funmode") }}
              </div>
            </div>
            <div
              v-if="gameShow === 4 && !isHotNew"
              :class="[
                item.game_category_id ? 'game-name-bg' + item.game_category_id : 'game-name-bg50',
                'game-name-bg',
                'level_show' + levelShow,
              ]"
            >
              <div class="game-text">{{ item.gameName }}</div>
            </div>
            <div class="scroll-number" v-if="jp_show && gameShow !== 4 && item.jpInfo && item.jpInfo.jpValue > 0 && !isHotNew">
              <!-- <div class="scroll-number" v-if="jp_show && gameShow !== 4"> -->
              <img :src="require('@/lobby_common/assets/game-item/bg.png')" class="scroll-bg" alt="" />
              <span class="num">{{ replacePoint(item.currentValue) }}</span>
            </div>
          </div>

          <div v-if="gameShow === 3 && !isHotNew" :class="['game-name', 'level_show' + levelShow]">
            <div class="game-text">{{ item.gameName }}</div>
          </div>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>
<script>
import gameItem from "@/lobby_common/mixins_components/game/game-item.js";
export default {
  mixins: [gameItem],
};
</script>
<style lang="scss" scoped>
.game-dom-img{
  position: relative;
  .isHotNewGameImg{
    transform: scale(1) !important;
  }
  .game-dom-bg {
    position: absolute;
    z-index: 2;
    height: 100%;
    > img {
      height: 97%;
      transform: scale(1.2) !important;
    }
  }
  .game-dom-top {
    font-size: 12px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    top: 10px;
    width: 100%;
    z-index: 1;
    .txt1 {
      height: 17px;
      line-height: 17px;
      background: #e2651a;
      padding: 0 10px;
      border-radius: 0 8px 8px 0;
    }
    .txt2 {
      display: flex;
      align-items: center;
      height: 17px;
      line-height: 17px;
      background: rgba(0, 0, 0, 0.5);
      padding: 0 15px 0 10px;
      border-radius: 8px 0 0 8px;
      > .num {
        height: 10px;
        margin-right: 5px;
      }
    }
  }
  .game-dom-bottom {
    font-size: 12px;
    text-align: center;
    border-radius: 0 0 8px 8px;
    bottom: 0;
    height: 20px;
    line-height: 20px;
    width: 100%;
    background: #e2651a;
    z-index: 1;
    &.game-dom-bottom1{
      background: var(--background-400);
    }
  }
}
.game-item-wrap .scroll-number {
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 14px;
  z-index: 2;
  .scroll-bg {
    width: 86%;
    margin: 0 auto;
    @media (max-width: 768px) {
      width: 95%;
      font-size: 12px;
    }
  }
  .num {
    // padding-top: 2px;
    position: absolute;
    // left: 50%;
    // top: 50%;
    left: 7%;
    top: 0;
    padding-top: 2%;
    // transform: translateX(-50%) translateY(-50%);
    width: 86%;
    height: 100%;
    overflow: hidden;
    // height: 20px;
    // line-height: 22px;
    // text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
      width: 94%;
      left: 3%;
      font-size: 13px;
    }
  }
}
.game-item-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
  transition: 0.5s;
  flex-shrink: 0;
  font-size: 14px;
  &.isHotNewGame {
    overflow: visible;
    .item-img {
      overflow: visible !important;
    }
    .lazy-load {
      border-radius: var(--radius-301);
    }
  }
  .game-name {
    // height: 48px;
    line-height: 24px;
    height: 24px;
    margin: 5px 0;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
    box-sizing: border-box;
    // font-weight: bold;
    text-align: center;
    display: flex;
    flex-direction: column;
    .game-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &.top {
      justify-content: flex-end;
    }
    &.level_show1 {
      .game-text {
        text-align: start;
      }
    }
    &.level_show2 {
      .game-text {
        text-align: center;
      }
    }
    &.level_show3 {
      .game-text {
        text-align: end;
      }
    }
  }

  .game-name-bg {
    &.level_show1 {
      .game-text {
        text-align: start;
      }
    }
    &.level_show2 {
      .game-text {
        text-align: center;
      }
    }
    &.level_show3 {
      .game-text {
        text-align: end;
      }
    }

    &.top {
      top: 0;
      bottom: none;
      transform: rotate(180deg);
      .game-text {
        transform: rotate(180deg);
      }
    }
  }
  .item-img img {
    transition: transform ease-in-out 0.5s;
    // transition: padding-bottom 0s;
  }
  &:hover .item-img img {
    // -webkit-transform: translateY(-12px);
    // -moz-transform: translateY(-12px);
    // -ms-transform: translateY(-12px);
    // -o-transform: translateY(-12px);
    // transform: translateY(-12px);
    // transition: all 0.5s;
    // -moz-transition: all 0.5s;
    // -webkit-transition: all 0.5s;
    transform: scale(1.1);
    @media (max-width: 768px) {
      transform: unset;
    }
  }
}

.item-img {
  position: relative;
  width: 100%;
  max-width: 300px;
  box-shadow: var(--boxShadow-600);
  background: linear-gradient(
    150deg,
    var(--background-1400) 10%,
    var(--background-500) 100%
  ); /* 从#ff7e5f到#feb47b的渐变 */

  ::v-deep img.el-image__inner {
    width: 100%;
  }
  &.lacyImg {
    padding-bottom: 36.36%;
  }
  img.lazy-load[lazy="loading"] {
    padding-bottom: 36.36%;
  }
  img.lazy-load[lazy="error"] {
    padding-bottom: 36.36%;
  }
  img.lazy-load[lazy="loaded"] {
    padding-bottom: 0%;
  }

  //img.lazy-load[lazy="loading"] {
  //  padding-bottom: 36.36%;
  // }
  // img.lazy-load[lazy="error"] {
  // padding-bottom: 36.36%;
  //}
  // img.lazy-load[lazy="loaded"] {
  //  padding-bottom: 0%;
  // }
  .tag-icon {
    width: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .tag-text {
    position: absolute;
    left: -1px;
    top: 8px;
    z-index: 2;
    width: 34px;
    height: 12px;
    transform: rotate(-38deg);
    font-size: 12px;
    line-height: 12px;
    color: var(--font-color-200);
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .brand-logo {
    width: 46%;
    position: absolute;
    right: 4%;
    bottom: 5px;
    z-index: 1;
  }

  .shiwan-mark {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
    border-radius: var(--radius-301);
    .nomal {
      width: 80%;
      background: var(--button-500);
      color: var(--font-color-200);
      text-align: center;
      border-radius: 16px;
      margin-bottom: 13px;
      height: 32px;
      line-height: 30px;
    }
    .chuangfang {
      position: relative;
      background: var(--button-600);
    }
    .shiwan {
      background: var(--button-700);
      // text-decoration: underline;
    }
  }

  .collection {
    position: absolute;
    z-index: 1;
    top: 5px;
    right: 5px;
  }

  img {
    width: 100%;
    display: block;
  }

  .tubiao {
    position: absolute;
    right: 0px;
    width: 40px;
    height: 35px;
    top: 0px;
    box-sizing: border-box;
    z-index: 999;
  }
}

.game-name-bg {
  position: absolute;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  bottom: 0;
  background-image: url("~@/assets/game/icon_sport.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 20px;
  font-weight: bold;
  // box-shadow: 0px 1px 2px 0px #666666;
  box-sizing: border-box;
  .game-text {
    text-align: center;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    color: var(--font-color-200);
    overflow: hidden; /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    box-sizing: border-box;
    padding: 0 5px;
    line-height: 24px;
    // min-height: 30px;
  }
}
@media (max-width: 768px) {
  .game-name-bg {
    padding-top: 20px;
    font-size: 14px;
    .game-text {
      line-height: 16px;
    }
  }
}
.game-name-bg10 {
  background-image: url("~@/assets/game/icon_slot.png");
}
.game-name-bg20 {
  background-image: url("~@/assets/game/icon_fishing.png");
}
.game-name-bg30 {
  background-image: url("~@/assets/game/icon_board.png");
}
.game-name-bg40 {
  background-image: url("~@/assets/game/icon_live.png");
}
.game-name-bg50 {
  background-image: url("~@/assets/game/icon_sport.png");
}
.game-name-bg60 {
  background-image: url("~@/assets/game/icon_ticket.png");
}
</style>
<style lang="scss">
.item-img-skeleton {
  position: relative;
  width: 100%;
  max-width: 300px;
  border-radius: var(--radius-300) !important;
  @media (max-width: 768px) {
    border-radius: var(--radius-301) !important;
  }
}
</style>
